module.exports = __webpack_public_path__ + "img/mall_banner.8ef0cee5.jpg";